const version = 1;

export default class VersionService {
  constructor(storage) {
    this.storage = storage;
  }
  getVersion() {
    return localStorage.getItem('appVersion');
  }
  setVersion() {
    localStorage.setItem('appVersion', version);
  }
  doUpdate() {
    switch(this.getVersion()) {
      case undefined:
      case null:
        this.storage.removeItem('latestYear');
        this.setVersion();
        break;
    }
  }

}
